export const capitalizeWord = (word: string): string => {
  if (!word) return '';
  const firstLetter = word.charAt(0);
  const remainLetters = word.slice(1);
  return firstLetter.toUpperCase() + remainLetters;
};

export const capitalizeString = (text: string): string => {
  const words = text.split(' ');
  return words.map((word) => capitalizeWord(word)).join(' ');
};
